export const validationRuleMessages = {
    isRequired: 'Dit veld moet ingevuld worden.',
    isEmail: 'Dit veld moet een geldig emailaddress bevatten.',
    isTrue: 'Dit veld moet aangevinkt worden.',
    isPDF: 'Het bestand moet een pdf zijn.',
};
